import { Redirect, Route, Switch } from "react-router-dom";
import { AppRouteUi } from "../config/appRoute";
import { LayoutPrivate } from "./privateLayout";
import { LayoutPublic } from "./publicLayout";
import { UIConfig } from "../config";

export function LayoutApplication(): JSX.Element {
  return (
    <>
      <Switch>
        <Redirect exact from="/" to={AppRouteUi.Login.Root()} />
        <Route path={UIConfig.publicRoute} component={LayoutPublic} />
        {/* <Route path={AppRouteUi.PrivacyPolicy.Root()} component={PagePrivacyPolicy} /> */}
        <Route path={UIConfig.privateRoute} component={LayoutPrivate} />
        <Route
          path="**"
          render={() => <Redirect to={AppRouteUi.NotFound.Root()} />}
        />
      </Switch>
    </>
  );
}
